(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  if (!$('#gallery-main') || !$('#hero-video')) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobileViewport = matchMedia('(max-width: 760px)');
  const openDialog = window.FergoliUI.openDialog;
  window.FERGOLI_IMAGES = JSON.parse($('#fergoli-gallery-data').textContent).map(image => ({...image,srcset:image.src640+' 640w, '+image.src+' 1280w'}));
  // Keep image selection independent of scroll; no layout-changing transitions.
  const images = window.FERGOLI_IMAGES;
  let currentImage = 0;
  let imageTimer;
  function displayImage(index) {
    const direction = index >= currentImage ? 1 : -1;
    currentImage = (index + images.length) % images.length;
    const next = images[currentImage];
    $('#gallery-main').dataset.imageKey = next.key;
    const caption = String(currentImage + 1).padStart(2, '0') + ' / ' + String(images.length).padStart(2, '0');
    clearTimeout(imageTimer);
    $('#gallery-main').style.setProperty('--gallery-exit', (-18 * direction) + 'px');
    $('#gallery-main').style.setProperty('--gallery-progress', (currentImage * 100) + '%');
    $('#gallery-main').classList.add('is-changing');
    $$('[data-image]').forEach(button => {
      const active = Number(button.dataset.image) === currentImage;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    $('#gallery-counter').textContent = caption;
    $('#gallery-caption').textContent = next.title;
    $('#lightbox-caption').textContent = caption;
    $('#lightbox-image').src = next.src;
    $('#lightbox-image').alt = next.alt;
    if ($('#lightbox').open) { requestedZoom = 1; zoomState = {scale:1,x:0,y:0}; requestAnimationFrame(() => fitZoom(1)); }
    imageTimer = setTimeout(() => {
      const img = $('#gallery-image');
      img.src = next.src;
      img.srcset = next.srcset;
      img.alt = next.alt;
      const finish = () => $('#gallery-main').classList.remove('is-changing');
      if (img.complete) finish(); else { img.onload = finish; img.onerror = finish; }
    }, reducedMotion.matches ? 0 : 120);
  }
  $('#gallery-main').style.setProperty('--gallery-count', String(images.length));
  $$('[data-image]').forEach(button => button.addEventListener('click', () => displayImage(Number(button.dataset.image))));
  ['gallery-prev','lightbox-prev'].forEach(id => $('#'+id).addEventListener('click', () => displayImage(currentImage - 1)));
  ['gallery-next','lightbox-next'].forEach(id => $('#'+id).addEventListener('click', () => displayImage(currentImage + 1)));
  ['gallery-main','lightbox'].forEach(id => $('#'+id).addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); displayImage(currentImage - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); displayImage(currentImage + 1); }
  }));
  $('#zoom-image').addEventListener('click', event => openZoom(event.currentTarget, 2));
  $$('[data-open-product-image]').forEach(button => button.addEventListener('click', () => {
    const index = images.findIndex(image => image.key === button.dataset.openProductImage);
    if (index < 0) return;
    displayImage(index);
    openZoom(button, 1);
  }));
  // Real image zoom: fit, 1x–4x, focal-point zoom, two-finger pinch and bounded pan.
  const zoomMath = window.CalmaZoom;
  const zoomStage = $('#zoom-stage');
  const zoomImage = $('#lightbox-image');
  let zoomState = {scale:1,x:0,y:0};
  let zoomBox = {width:1,height:1,stageWidth:1,stageHeight:1};
  let requestedZoom = 1;
  let dragStart = null;
  let pinchStart = null;
  let gestureMoved = false;
  const pointers = new Map();
  function drawZoom() {
    zoomState = zoomMath.clampState(zoomState,zoomBox);
    zoomImage.style.transform = `translate3d(${zoomState.x}px,${zoomState.y}px,0) scale(${zoomState.scale})`;
    $('#zoom-level').textContent = Math.round(zoomState.scale * 100) + ' %';
    $('#zoom-out').disabled = zoomState.scale <= 1.001;
    $('#zoom-in').disabled = zoomState.scale >= 3.999;
    zoomStage.classList.toggle('is-zoomed',zoomState.scale > 1.01);
  }
  function fitZoom(scale = requestedZoom) {
    if (!$('#lightbox').open || !zoomStage.clientWidth || !zoomStage.clientHeight) return;
    const naturalWidth = zoomImage.naturalWidth || 1536;
    const naturalHeight = zoomImage.naturalHeight || 1024;
    const fitted = zoomMath.fit(naturalWidth,naturalHeight,zoomStage.clientWidth,zoomStage.clientHeight);
    zoomBox = {...fitted,stageWidth:zoomStage.clientWidth,stageHeight:zoomStage.clientHeight};
    zoomImage.style.width = fitted.width + 'px';
    zoomImage.style.height = fitted.height + 'px';
    zoomImage.style.marginLeft = -fitted.width / 2 + 'px';
    zoomImage.style.marginTop = -fitted.height / 2 + 'px';
    zoomState = {scale,x:0,y:0};
    drawZoom();
  }
  function localPoint(x,y) {
    const rect = zoomStage.getBoundingClientRect();
    return {x:x-rect.left-rect.width/2,y:y-rect.top-rect.height/2};
  }
  function changeZoom(scale,point={x:0,y:0}) {
    zoomState = zoomMath.zoomAt(zoomState,scale,point,zoomBox);
    requestedZoom = zoomState.scale;
    drawZoom();
  }
  function openZoom(origin,scale=1) {
    requestedZoom = scale;
    zoomState = {scale,x:0,y:0};
    zoomImage.src = images[currentImage].src;
    zoomImage.alt = images[currentImage].alt;
    openDialog($('#lightbox'),origin);
    requestAnimationFrame(() => {fitZoom(scale);zoomStage.focus({preventScroll:true});});
  }
  zoomImage.addEventListener('load', () => fitZoom(requestedZoom));
  $('#zoom-in').addEventListener('click', () => changeZoom(zoomState.scale + .5));
  $('#zoom-out').addEventListener('click', () => changeZoom(zoomState.scale - .5));
  $('#zoom-reset').addEventListener('click', () => {requestedZoom=1;fitZoom(1);});
  $('#gallery-main').addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.id === 'gallery-main') {event.preventDefault();openZoom(event.currentTarget,2);}
  });
  $('#lightbox').addEventListener('keydown', event => {
    if (['+','=','-','0'].includes(event.key)) {
      event.preventDefault();
      if (event.key === '0') {requestedZoom=1;fitZoom(1);}
      else changeZoom(zoomState.scale + (event.key === '-' ? -.5 : .5));
    }
  });
  function pinchData() {
    const [a,b] = [...pointers.values()];
    return {distance:Math.max(1,Math.hypot(a.x-b.x,a.y-b.y)),center:{x:(a.x+b.x)/2,y:(a.y+b.y)/2}};
  }
  zoomStage.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    event.preventDefault();
    zoomStage.setPointerCapture(event.pointerId);
    pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
    if (pointers.size === 1) {
      gestureMoved=false;
      dragStart={x:event.clientX,y:event.clientY,state:{...zoomState}};
    } else if (pointers.size === 2) {
      gestureMoved=true;
      pinchStart={...pinchData(),state:{...zoomState}};
    }
  });
  zoomStage.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId)) return;
    event.preventDefault();
    pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
    if (pointers.size >= 2 && pinchStart) {
      const current=pinchData();
      const center=localPoint(pinchStart.center.x,pinchStart.center.y);
      const next=zoomMath.zoomAt(pinchStart.state,pinchStart.state.scale*current.distance/pinchStart.distance,center,zoomBox);
      next.x+=current.center.x-pinchStart.center.x;
      next.y+=current.center.y-pinchStart.center.y;
      zoomState=zoomMath.clampState(next,zoomBox);
      requestedZoom=zoomState.scale;
      drawZoom();
    } else if (dragStart) {
      const dx=event.clientX-dragStart.x,dy=event.clientY-dragStart.y;
      if (Math.abs(dx)+Math.abs(dy)>5) gestureMoved=true;
      zoomState=zoomMath.clampState({...dragStart.state,x:dragStart.state.x+dx,y:dragStart.state.y+dy},zoomBox);
      drawZoom();
    }
  });
  function endZoomPointer(event,cancelled=false) {
    if (!pointers.has(event.pointerId)) return;
    const tapped=pointers.size===1 && !gestureMoved && !cancelled;
    pointers.delete(event.pointerId);
    if (zoomStage.hasPointerCapture(event.pointerId)) zoomStage.releasePointerCapture(event.pointerId);
    pinchStart=null;
    if (pointers.size===1) {
      const point=[...pointers.values()][0];
      dragStart={...point,state:{...zoomState}};
      gestureMoved=true;
    } else if (!pointers.size) {
      dragStart=null;
      if (tapped) changeZoom(zoomState.scale > 1.05 ? 1 : 2,localPoint(event.clientX,event.clientY));
    }
  }
  zoomStage.addEventListener('pointerup',event=>endZoomPointer(event));
  zoomStage.addEventListener('pointercancel',event=>endZoomPointer(event,true));
  zoomStage.addEventListener('wheel',event=>{
    event.preventDefault();
    changeZoom(zoomState.scale*(event.deltaY<0?1.12:.89),localPoint(event.clientX,event.clientY));
  },{passive:false});
  $('#lightbox').addEventListener('close',()=>{pointers.clear();pinchStart=null;dragStart=null;});
  window.addEventListener('resize',()=>{if($('#lightbox').open)fitZoom(zoomState.scale);},{passive:true});

  let pointerStart = null;
  let wasSwipe = false;
  $('#gallery-main').addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse' || event.target.closest('button')) return;
    pointerStart = {x:event.clientX,y:event.clientY};
    wasSwipe = false;
  }, {passive:true});
  $('#gallery-main').addEventListener('pointerup', event => {
    if (!pointerStart) return;
    const dx = event.clientX - pointerStart.x;
    const dy = event.clientY - pointerStart.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
      displayImage(currentImage + (dx < 0 ? 1 : -1));
      wasSwipe = true;
      setTimeout(() => { wasSwipe = false; }, 350);
    }
    pointerStart = null;
  }, {passive:true});
  $('#gallery-main').addEventListener('pointercancel', () => { pointerStart = null; });
  $('#gallery-image').addEventListener('click', event => { if (!wasSwipe) openZoom(event.currentTarget, 1); });

  if ('IntersectionObserver' in window) {
    if (!reducedMotion.matches) {
      const revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
        });
      }, {threshold:.08,rootMargin:'0px 0px -12px 0px'});
      $$('.reveal').forEach(el => revealObserver.observe(el));
      document.documentElement.classList.add('motion-ready');
    }
    let heroVisible = true;
    let buyVisible = false;
    const buyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.target.classList.contains('hero')) heroVisible = entry.isIntersecting; else buyVisible = entry.isIntersecting; });
      $('#mobile-buy').classList.toggle('is-visible', !heroVisible && !buyVisible);
    }, {threshold:0});
    buyObserver.observe($('.hero'));
    if ($('.buy-row')) buyObserver.observe($('.buy-row'));
  }

  // Play the supplied T7S footage as a pre-cut loop. The page geometry never changes.
  const hero = $('.hero');
  const heroVideo = $('#hero-video');
  const motionButton = $('#toggle-hero-motion');
  let userPaused = false;
  let heroInView = true;
  let allowReducedPlayback = false;
  let playPending = false;
  let autoplayBlocked = false;
  heroVideo.muted = true;
  heroVideo.defaultMuted = true;
  heroVideo.playsInline = true;
  heroVideo.loop = true;
  function heroShouldPause() {
    return document.hidden || Boolean(document.querySelector('dialog[open]')) || !heroInView || userPaused || autoplayBlocked || (reducedMotion.matches && !allowReducedPlayback);
  }
  function renderHeroPlayback(paused) {
    hero.dataset.motion = paused ? 'paused' : 'running';
    motionButton.setAttribute('aria-label',paused?'Hintergrundvideo abspielen':'Hintergrundvideo pausieren');
    motionButton.setAttribute('aria-pressed',String(!paused));
    motionButton.innerHTML = '<svg class="icon"><use href="'+(paused?'#i-play':'#i-pause')+'"/></svg>';
    motionButton.classList.toggle('is-paused',paused);
  }
  function updateHeroMotion() {
    if (heroShouldPause()) { heroVideo.pause(); renderHeroPlayback(true); return; }
    if (!heroVideo.paused) { renderHeroPlayback(false); return; }
    if (playPending) return;
    playPending = true;
    const attempt = heroVideo.play();
    if (attempt && typeof attempt.then === 'function') {
      attempt.then(() => {
        playPending = false;
        if (heroShouldPause()) { heroVideo.pause(); renderHeroPlayback(true); }
        else renderHeroPlayback(false);
      }).catch(error => {
        playPending = false;
        if (error?.name !== 'AbortError') autoplayBlocked = true;
        renderHeroPlayback(true);
        if (error?.name === 'AbortError') requestAnimationFrame(() => {
          if (!heroShouldPause()) updateHeroMotion();
        });
      });
    } else {
      playPending = false;
      renderHeroPlayback(heroVideo.paused);
    }
  }
  motionButton.hidden = false;
  motionButton.addEventListener('click',()=>{
    if (hero.dataset.motion === 'running') userPaused = true;
    else { userPaused = false; autoplayBlocked = false; allowReducedPlayback = true; }
    updateHeroMotion();
  });
  heroVideo.addEventListener('playing',()=>{
    if (heroShouldPause()) heroVideo.pause();
    renderHeroPlayback(heroVideo.paused);
  });
  heroVideo.addEventListener('pause',()=>renderHeroPlayback(true));
  heroVideo.addEventListener('loadeddata',updateHeroMotion);
  heroVideo.addEventListener('error',()=>{autoplayBlocked=true;renderHeroPlayback(true);});
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries=>{heroInView=entries[0].isIntersecting;updateHeroMotion();},{threshold:.01}).observe(hero);
  }
  document.addEventListener('visibilitychange',updateHeroMotion);
  document.addEventListener('calma-dialog-change',updateHeroMotion);
  reducedMotion.addEventListener('change',()=>{
    allowReducedPlayback = false;
    if(reducedMotion.matches)document.documentElement.classList.remove('motion-ready');
    updateHeroMotion();
  });
  updateHeroMotion();

  // Transform-only parallax and a slim reading-progress line; no scroll-driven sizing.
  let animationScheduled=false;
  function updateScrollEffects() {
    animationScheduled=false;
    const total=document.documentElement.scrollHeight-window.innerHeight;
    const progress=total>0?Math.max(0,Math.min(1,window.scrollY/total)):0;
    document.documentElement.style.setProperty('--page-progress',String(progress));
    if(!reducedMotion.matches && !mobileViewport.matches && heroInView){
      const offset=Math.max(0,Math.min(50,-$('.hero').getBoundingClientRect().top*.12));
      $('.hero').style.setProperty('--hero-shift',offset+'px');
    } else if(mobileViewport.matches) $('.hero').style.setProperty('--hero-shift','0px');
  }
  function queueScrollEffects(){if(!animationScheduled){animationScheduled=true;requestAnimationFrame(updateScrollEffects);}}
  window.addEventListener('scroll',queueScrollEffects,{passive:true});
  window.addEventListener('resize',queueScrollEffects,{passive:true});
  queueScrollEffects();

})();
